var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66016 19L9.83301 13H14.1435L17.3354 19H6.66016Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78876 10.8944L9.99991 10V4H13.9999V10L14.2111 10.8944L18.7638 20L5.23598 20L9.78876 10.8944ZM15.9999 4V10L20.5527 19.1056C21.2176 20.4354 20.2506 22 18.7638 22H5.23598C3.74922 22 2.78222 20.4354 3.44712 19.1056L7.99991 10V4H7.99984L7 3L7.99984 2H9.99991H13.9999H16L16.9999 3L16 4H15.9999Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.2b9fd7971e9e98958f0ffee587914bfa.svg";
export { ForwardRef as ReactComponent };